<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
            <open-on-site
              :source-route="source.route"
            />
            <button class="btn btn-danger btn-sm" @click="$_deleteEntity(`news/${source.id}`)">
              Delete
              <span ref="deleteBtnLoader" class="btn-loader" style="display: none;" />
            </button>
          </h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Short title</label>
                  <div class="col-md-10">
                    <input
                      id="short_title"
                      v-model="entity.teaser.short_title"
                      type="text"
                      placeholder="Enter short title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Date *</label>
                  <div class="col-md-10">
                    <datepicker
                      v-model="entity.date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body *</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Cover</label>
                  <div class="col-md-10">
                    <image-uploader
                      :uploaded-img-url="$_coverUrl"
                      @changeFile="$_coverChange"
                      @returnedOldFile="$_coverRestore"
                      @existingFileRemoved="$_coverRemove"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label for="body" class="col-md-2 form-control-label">Files</label>
                      <div class="col-md-10">
                        <dropzone
                          v-if="dropzoneOptions"
                          id="files-uploader"
                          ref="dropzone"
                          :options="dropzoneOptions"
                          :destroy-dropzone="false"
                          @vdropzone-file-added="fileAdded"
                          @vdropzone-removed-file="fileRemoved"
                        />
                        <div v-else>Dropzone can't work without upload url.</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured.section_id" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured.section_id && entity.featured.section_id > 0" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featured.featured_body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        :already-choosen-refs="entity.loadedReferences"
        @changeRefs="$_changeRefs"
      />

      <terms
        :already-choosen-terms="entity.terms"
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            News has modified successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import Datepicker from '@/global/components/Datepicker';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
import { uploadStatus } from '@/helpers/constants';
import config from '../../../config';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

const { SUCCESS } = uploadStatus;

export default {
  name: 'NewsEdit',

  components: {
    dropzone: Dropzone,
    referencer: Referencer,
    terms: Terms,
    datepicker: Datepicker,
    'open-on-site': OpenOnSiteButton,
  },

  mixins: [EditPageMixin, CommonPageMixin],

  data() {
    return {
      dropzoneSettings: {
        maxFiles: 50,
        maxFilesize: 100,
      },
      uploadedFiles: [],
      files: [],
    };
  },

  computed: {
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'files[]',
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}news/${this.$route.params.id}/files`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        addRemoveLinks: true,
        autoProcessQueue: false,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFiles() {
      const getUploadings = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadings) {
        return [];
      }
      return getUploadings(this.$route.params.id, 'news');
    },
  },

  watch: {
    uploadingFiles: {
      handler(val) {
        this.uploadedFiles = val.filter(file => file.status === SUCCESS).map(file => file.file);
        const { dropzone } = this.$refs;
        if (dropzone) {
          this.uploadedFiles.forEach(file => dropzone.removeFile(file));
          this.uploadedFiles.forEach((file) => {
            dropzone.manuallyAddFile(file, '/');
            $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', 'static/img/file-thumb.jpg');
          });
        }
      },
      deep: true,
    },
  },

  methods: {
    manuallyAddFiles() {
      for (let i = 0; i < this.entity.files.length; i += 1) {
        const file = {
          file: {
            name: this.entity.files[i].file_name,
            size: this.entity.files[i].size,
          },
          url: this.entity.files[i].public_url,
          thumb: this.entity.files[i].thumbnail,
        };
        this.$refs.dropzone.manuallyAddFile(file.file, file.url);
        if (!this.entity.files[i].mime_type.match(/image.*/)) {
          $('#files-uploader .dz-preview').last().find('.dz-image img').attr('src', file.thumb);
        }
      }
    },
    fileAdded(file) {
      this.files.push(file);
    },
    fileRemoved(file) {
      // TODO: when file is not loaded, is has no ID. Backend issue.
      const fileIndex = _.findIndex(this.entity.files, item => item.file_name === file.name && item.size === file.size);
      if (fileIndex === -1) return;
      const fileId = this.entity.files[fileIndex].id;
      this.$apiHttp.delete(`${this.$config.app_api.prefix}news/${this.$route.params.id}/files/${fileId}`)
        .then(() => {
          this.entity.files.splice(fileIndex, 1);
          this.files = this.files.filter(item => file !== item);
        }).catch((error) => {
          console.error('error in delete file in site page request - ', error);
        });
    },
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Title', value: this.entity.title, type: 'minLength', maxLength: 3 },
        { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' },
        { name: 'Body', value: this.entity.body, type: 'required' },
        { name: 'Body', value: this.entity.body, type: 'minLength', maxLength: 10 },
        { name: 'Date', value: this.entity.date, type: 'required' },
      ]);
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}news/${this.$route.params.id}`, {
        params: {
          with: ['references', 'cover', 'files', 'terms', 'path_alias', 'featured'],
        },
      }).then((response) => {
        this.source = this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(this.source, 'cover')) {
          this.source.cover = null;
        }
        this.entity = _.cloneDeep(this.source);
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        setTimeout(this.manuallyAddFiles, 100);
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting news request' });
        console.error('Error in get single news query', error);
      });
    },
    saveCoverRequest() {
      const postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}news/${this.$route.params.id}/cover`, postFormData);
    },
    deleteCoverRequest() {
      return this.$apiHttp.delete(`${this.$config.app_api.prefix}news/${this.$route.params.id}/cover`);
    },
    saveRequest() {
      const { entity } = this;
      const postFormData = this.$_addDefaultFormData();

      postFormData.append('title', entity.title);
      postFormData.append('body', entity.body);
      postFormData.append('date', entity.date);
      postFormData.append('short_title', entity.teaser.short_title ? entity.teaser.short_title : '');
      postFormData.append('featured', entity.featured.section_id ? entity.featured.section_id : '');
      postFormData.append('featured_body', entity.featured.featured_body);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}news/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const files = this.files.filter(file => !file.manuallyAdded);
      const { prefix, host } = this.$config.app_api;
      const entityId = this.$route.params.id;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const vm = this;
      const dispatchStartUpload = (contentType) => {
        if (files && files.length > 0) {
          vm.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId,
            files: [...files],
            token,
            contentType,
          });
          vm.files = [];
        }
      };
      if (!this.$_coverIsChanged) {
        this.saveRequest().then((response) => {
          this.$_successSave();
          dispatchStartUpload(response.data.content_type);
        }).catch((error) => {
          this.$_errorSave(error);
          console.error('Error in update news query', error);
        });
      } else if (!this.entity.cover) {
        axios.all([this.deleteCoverRequest(), this.saveRequest()]).then(axios.spread((cover, entity) => {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      } else {
        axios.all([this.saveCoverRequest(), this.saveRequest()]).then(axios.spread((cover, entity) => {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?ea36d3e6